

import { Box, Typography, Grid, Paper } from '@mui/material';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function SpaAnalytics({ spaId }) {
  const demoStats = {
    totalBookings: 125,
    mostPopularTreatment: 'Swedish Massage',
    totalRevenue: '$3,200'
  };

  const barChartData = {
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    datasets: [
      {
        label: 'Bookings',
        data: [10, 15, 20, 12, 18, 22, 28],
        backgroundColor: 'rgba(75,192,192,0.6)'
      }
    ]
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Spa Analytics
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={4}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle1">Total Bookings</Typography>
            <Typography variant="h6">{demoStats.totalBookings}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle1">Popular Treatment</Typography>
            <Typography variant="h6">{demoStats.mostPopularTreatment}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle1">Total Revenue</Typography>
            <Typography variant="h6">{demoStats.totalRevenue}</Typography>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle1" gutterBottom>
              Weekly Booking Trend
            </Typography>
            <Bar data={barChartData} />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}